import { Formik } from "formik";
import * as Yup from "yup";
import { Modal } from "rsuite";
import { Col, Row } from "reactstrap";
import CustomInput from "../../components/input";
import { CheckBox } from "devextreme-react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { useState } from "react";
import KVKK from "../garage/offer-accept/kvk";
import { Button } from "../../components";
import { ButtonType } from "../../components/button";
import { AiOutlineArrowRight } from "react-icons/ai";
import { createContact } from "../../redux/definitions";
import Checkmark from "react-typescript-checkmark";
import CustomLoader from "../../components/loader";
const ContactModal = ({
  open,
  car,
  name,
  close,
}: {
  name: string;
  car: any;
  open: boolean;
  close: () => void;
}) => {
  const dispatch = useDispatch();
  const localize = useSelector(getLocalized);
  const [showTerm, setShowTerm] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const validationSchema = Yup.object({
    CompanyName: Yup.string().required(localize.getString("required")),
    Name: Yup.string().required(localize.getString("required")),
    Surname: Yup.string().required(localize.getString("required")),
    Phone: Yup.string()
      .required(localize.getString("required"))
      .test("len", (val) => val?.toString().length === 10)
      .test("startwith", "Başında 0 olmadan giriniz", (val) => {
        let check = val?.startsWith("0") ? false : true;
        return check;
      }),
    Email: Yup.string()
      .required(localize.getString("required"))
      .email(localize.getString("emailerror")),
    Approved: Yup.boolean().oneOf([true], localize.getString("accepterror")),
  });

  return (
    <>
      <Modal
        className="offer-end-modal"
        open={visible}
        size="xs"
        onClose={() => {
          setVisible(false);
        }}
      >
        <Modal.Header></Modal.Header>
        <div>
          <Modal.Body className="modal-body" style={{ padding: "10px 20px" }}>
            <div style={{ marginBlock: 10 }}>
              <Checkmark
                backgroundColor="rgb(255, 68, 54)"
                animationDuration={0.8}
                explosion={1.2}
              />
            </div>
            <div style={{ textAlign: "center" }} className="Modaltext">
              Kiralama teklif talebiniz bize ulaştı. En kısa sürede sizinle
              iletişime geçeceğiz.  
            </div>
          </Modal.Body>
        </div>
      </Modal>
      <Modal size={"xs"} open={open} onClose={close}>
        <Modal.Header
          className="header-font"
          style={{
            paddingBlock: 20,
            textAlign: "center",
          }}
        >
          {"İletişim Formu"}
        </Modal.Header>
        <Modal.Body>
          <div
            className="w-100 d-flex justify-content-center gap-2"
            style={{ paddingInlineStart: 20 }}
          >
            <Formik
              initialValues={{
                CarName: name,
                CarId: car.Id,
                Name: "",
                Surname: "",
                Email: "",
                CompanyName: "",
                Phone: "",
                TaxNumber: "-",
                TaxOffice: "-",
                Approved: false,
                Message: "",
              }}
              onSubmit={(values) => {
                setLoader(true);
                dispatch(
                  createContact({
                    payload: {
                      onSuccess: () => {
                        setLoader(false);
                        close();
                        setVisible(true);
                      },
                      onError: () => {},
                    },
                    body: values,
                  })
                );
              }}
              validationSchema={validationSchema}
            >
              {({ handleSubmit, setFieldValue, values, errors, touched }) => {
                return (
                  <div className="w-100">
                    <Row className="w-100">
                      {loader && <CustomLoader />}
                      <Col>
                        <CustomInput
                          value={values.CompanyName}
                          error={errors.CompanyName}
                          label={localize.getString("companyName")}
                          onChanged={(e) => setFieldValue("CompanyName", e)}
                        />
                      </Col>
                    </Row>

                    <Row className="w-100">
                      <Col md={6}>
                        <CustomInput
                          value={values.Name}
                          error={errors.Name}
                          label={localize.getString("name")}
                          onChanged={(e) => setFieldValue("Name", e)}
                        />
                      </Col>
                      <Col md={6}>
                        <CustomInput
                          value={values.Surname}
                          error={errors.Surname}
                          label={localize.getString("surname")}
                          onChanged={(e) => setFieldValue("Surname", e)}
                        />
                      </Col>
                    </Row>

                    <Row className="w-100">
                      <Col md={6}>
                        <CustomInput
                          type={"number"}
                          showError
                          value={values.Phone}
                          error={errors.Phone}
                          label={localize.getString("phone")}
                          onChanged={(e) =>
                            e.length <= 10 && setFieldValue("Phone", e)
                          }
                        />
                      </Col>
                      <Col md={6}>
                        <CustomInput
                          error={errors.Email}
                          value={values.Email}
                          label={localize.getString("email")}
                          onChanged={(e) => setFieldValue("Email", e)}
                        />
                      </Col>
                      <Col md={12}>
                        <CustomInput
                          error={errors.Message}
                          value={values.Message}
                          label={"Mesaj"}
                          onChanged={(e) => setFieldValue("Message", e)}
                        />
                      </Col>
                    </Row>
                    <div>
                      <div>
                        <CheckBox
                          name="Approved"
                          className="checkbox"
                          value={values.Approved}
                          onValueChanged={(e: any) =>
                            setFieldValue("Approved", e.value)
                          }
                        />
                        <label
                          className="Modaltext"
                          style={{
                            marginBlockStart: 18,
                            marginInlineStart: 10,
                          }}
                        >
                          <span
                            onClick={() => setShowTerm(true)}
                            style={{ cursor: "pointer", color: "#ff4436" }}
                          >
                            KVKK
                          </span>{" "}
                          Sözleşme Onayı
                        </label>
                        <p className="errors Modaltext">{errors.Approved}</p>
                        <Modal
                          className="offer-modal"
                          open={showTerm}
                          onClose={() => setShowTerm(false)}
                          size="lg"
                        >
                          {" "}
                          <Modal.Header
                            onClose={() => setShowTerm(false)}
                          ></Modal.Header>
                          <div>
                            <KVKK />
                          </div>
                        </Modal>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        customClassName="btnTeklifTalepGonder"
                        style={{
                          width: "max-content",
                          marginInlineEnd: 20,
                          fontSize: 24,
                          fontWeight: 700,
                        }}
                        icon={<AiOutlineArrowRight></AiOutlineArrowRight>}
                        buttonType={ButtonType.newColored}
                        title={"Gönder"}
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                );
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ContactModal;
